import {
  CoastIcon,
  DaiIcon,
  HexIcon,
  PulseChainIcon,
  PulseXIcon,
  TideIcon,
  UsdcIcon,
  UsdtIcon,
  WaitV2Icon,
} from '~public'
import { GloryIcon } from '~public/icons/GloryIcon'
import { IncIcon } from '~public/icons/IncIcon'
import { PHLPv2Icon } from '~public/icons/PHLPv2Icon'
//PRVX change here
import { ProveXIcon } from '~public/icons/ProveXIcon'

export const cryptoCurrencies = [
  {
    code: 'PLS',
    flag: <PulseChainIcon style={{ height: '40px', width: '40px' }} />,
  },
  {
    code: 'wPLS',
    flag: <PulseChainIcon style={{ height: '40px', width: '40px' }} />,
  },
  {
    code: 'CST',
    flag: <CoastIcon style={{ height: '30px', width: '30px', marginLeft: '5px', marginRight: '5px' }} />,
  },
  {
    code: 'TIDE',
    flag: <TideIcon style={{ height: '30px', width: '30px', marginLeft: '5px', marginRight: '5px' }} />,
  },
  {
    code: 'GLORY',
    flag: <GloryIcon style={{ height: '30px', width: '30px', marginLeft: '5px', marginRight: '5px' }} />,
  },
  {
    code: 'PLSX',
    flag: <PulseXIcon style={{ height: '30px', width: '30px', marginLeft: '5px', marginRight: '5px' }} />,
  },
  {
    code: 'HEX',
    flag: <HexIcon style={{ height: 20, width: 20 }} />,
  },
  {
    code: 'eHEX',
    flag: <HexIcon style={{ height: 20, width: 20 }} />,
  },
  {
    code: 'WAIT',
    flag: <WaitV2Icon style={{ height: '30px', width: '30px', marginLeft: '5px', marginRight: '5px' }} />,
  },
  {
    code: 'INC',
    flag: <IncIcon style={{ height: '30px', width: '30px', marginLeft: '5px', marginRight: '5px' }} />,
  },
  {
    code: 'PHLPv2',
    flag: <PHLPv2Icon style={{ height: '30px', width: '30px', marginLeft: '5px', marginRight: '5px' }} />,
  },
  //PRVX change here
  {
    code: 'PRVX',
    flag: <ProveXIcon style={{ height: '30px', width: '30px', marginLeft: '5px', marginRight: '5px' }} />,
  },
  {
    code: 'USDC',
    flag: <UsdcIcon style={{ height: '30px', width: '30px', marginLeft: '5px', marginRight: '5px' }} />,
  },
  {
    code: 'USDT',
    flag: <UsdtIcon style={{ height: '30px', width: '30px', marginLeft: '5px', marginRight: '5px' }} />,
  },
  {
    code: 'DAI',
    flag: <DaiIcon style={{ height: '30px', width: '30px', marginLeft: '5px', marginRight: '5px' }} />,
  },
]
